import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import Signup from "./Components/Authorization/Signup";
import LoginForm from "./Components/Authorization/Login";
import ForgotPassword from "./Components/Authorization/ForgotPassword";
import Layout from "./Components/Pages/Layout";
import Dashboard from "./Components/Pages/Dashboard";
import "./App.css";
import Questions from "./Components/Pages/Questions";
import PrivateRoute from "./Components/Authorization/PrivateRoute";
import PageNotFound from "./Components/Pages/PageNotFound";
import Documents from "./Components/Pages/Documents";
import ViewDocuments from "./Components/Pages/ViewDocuments";
import MyProfile from "./Components/Pages/MyProfile";
import EmailVerification from "./Components/Pages/EmailVerification";
import PlansPage from "./Components/Pages/Pricing";
import Billing from "./Components/Pages/Billing";
import CardDetails from "./Components/Pages/CardDetails";
import TransactionHistory from "./Components/Pages/TransactionHistory";
import Support from "./Components/Pages/Support";
import CreateTicket from "./Components/Pages/CreateTicket";
import UserPasswordChange from "./Components/Authorization/UserPasswordChange";
import NewPricing from "./Components/Pages/NewPricing";
import Invoice from "./Components/Pages/Invoice";
import PublicRoute from "./Components/Authorization/PublicRoute";
import Answers from "./Components/Pages/Answers";
import ProductValuation from "./Components/Pages/ProductValuation";
// import DocumentAnalyticsChart from "./Components/Pages/Charts";
const theme = createTheme({
  palette: {
    primary: { main: "#66a321" },
  },
  typography: {
    fontFamily: "Be Vietnam Pro, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "5px",
          textTransform: "none",
          fontSize: "1rem",
          // backgroundColor: " #014671",
          backgroundColor: " #c53131",
          border: 'none',
          color: "#fff"
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            height: "40px",
            backgroundColor: "transparent !important",
          },
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          position: "absolute",
          top: 60,
          margin: 0,
        },
      },
      defaultProps: {
        disableBackdropClick: true,
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#07659c",
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicRoute><LoginForm /></PublicRoute>} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/emailverification" element={<EmailVerification />} />
          <Route path="/passwordchange" element={<UserPasswordChange />} />

          {/* Private Routes */}
          <Route path="/dashboard" element={<PrivateRoute><Layout showBreadcrumbs={true}><Dashboard /></Layout ></PrivateRoute>} />
          <Route path="/create" element={<PrivateRoute><Layout showBreadcrumbs={true}><Questions /></Layout ></PrivateRoute>} />
          <Route path="/documents" element={<PrivateRoute><Layout showBreadcrumbs={true}><Documents /></Layout ></PrivateRoute>} />
          <Route path="/documents/answers"element={<PrivateRoute><Layout showBreadcrumbs={false}><Answers /></Layout ></PrivateRoute>} />
          <Route path="/viewdocument" element={<Layout showBreadcrumbs={true}><ViewDocuments /></Layout >} />
          <Route path="/myprofile" element={<PrivateRoute><Layout showBreadcrumbs={true}><MyProfile /></Layout ></PrivateRoute>} />
          {/* <Route path="/plans" element={<PrivateRoute><Layout showBreadcrumbs={true}><PlansPage /></Layout ></PrivateRoute>} /> */}
          <Route path="/plans" element={<PrivateRoute><Layout showBreadcrumbs={true}><NewPricing /></Layout ></PrivateRoute>} />
          <Route path="/plans/billing" element={<PrivateRoute><Layout showBreadcrumbs={true}><Billing /></Layout ></PrivateRoute>} />
          <Route path="/plans/cardDetails" element={<PrivateRoute><Layout showBreadcrumbs={true}><CardDetails /></Layout ></PrivateRoute>} />
          <Route path="/plans/transactionhistory" element={<PrivateRoute><Layout showBreadcrumbs={true}><TransactionHistory /></Layout ></PrivateRoute>} />
          <Route path="/support" element={<PrivateRoute><Layout showBreadcrumbs={true}><Support /></Layout ></PrivateRoute>} />
          <Route path="/support/createticket" element={<PrivateRoute><Layout showBreadcrumbs={true}><CreateTicket /></Layout ></PrivateRoute>} />
          <Route path="/plans/transactionhistory/invoice" element={<Layout showBreadcrumbs={true}><Invoice /></Layout >}/>
          <Route path="/productvaluation" element={<PrivateRoute><Layout showBreadcrumbs={true}><ProductValuation /></Layout ></PrivateRoute>} />
          {/* <Route path="/newPricing" element={<PrivateRoute><Layout showBreadcrumbs={true}><NewPricing /></Layout ></PrivateRoute>} /> */}
          {/* <Route path="/charts" element={<PrivateRoute><Layout showBreadcrumbs={true}><DocumentAnalyticsChart /></Layout ></PrivateRoute>} /> */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
